import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/session",
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(data);
        window.history.replaceState({}, document.title, "/admin");
        navigate("/admin", { replace: true, state: { user: data } });
      } catch {
        navigate("/admin/login", { replace: true, state: { error: "Login failed" } });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50">
      <div className="text-center">
        <div className="w-10 h-10 mx-auto mb-4 border-2 border-[#E63946] border-t-transparent rounded-full animate-spin" />
        <div className="text-sm text-gray-500 uppercase tracking-[0.2em]">Signing you in…</div>
      </div>
    </div>
  );
}
